import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useAutoDiscriminatorField } from "../../hooks/use-discriminator-field.js";
import { useSchemaContext } from "../../hooks/use-schema-context.js";
import { resolveRef } from "../../utils/schema-context.js";
// biome-ignore lint/nursery/noImportCycles: Intentional cycle for recursive form rendering (UnionField -> ObjectField -> ShapeField -> UnionField)
import { ObjectField } from "../object-field.js";
/**
 * Renders the fields of a discriminated union's active variant (no type selector).
 * Used when the type selector is rendered elsewhere (e.g., in array item header or collapsible header).
 *
 * Resolves the active variant via the discriminator, then delegates to ObjectField
 * with the variant's properties (excluding the discriminator property).
 */
export function UnionField({ path, schema, config, disabled, readOnly }) {
    const ctx = useSchemaContext();
    const resolvedSchema = useMemo(() => resolveRef(ctx, schema), [ctx, schema]);
    const discriminator = useAutoDiscriminatorField({ path, schema: resolvedSchema });
    if (!discriminator.currentSchema) {
        return null;
    }
    return (_jsx(ObjectField, { path: path, schema: discriminator.currentSchema, parentRef: discriminator.currentRef, exclude: discriminator.discriminatorPath ? [discriminator.discriminatorPath] : undefined, config: config, disabled: disabled, readOnly: readOnly }));
}
